"use client"
import { ImageUploadField } from "@/(admin)/modules/ui-builder/config/lib/ImageUploadField"
import { ComponentConfig } from "@measured/puck"
import CKEditorWrapper from "../../../../../../lib/config/lib/CkeditorWrapper"
import { commonStylesProps } from "../../lib/commonCSSProps"
import { ProfileUserCardProps, RenderConfig } from "./RenderConfig"

export const ProfileUserCard: ComponentConfig<ProfileUserCardProps> = {
  label: "Profile User Card",
  //@ts-ignore
  fields: {
    image: {
      label: "Image",
      type: "custom",
      render: props => <ImageUploadField {...props} />,
    },
    title: {
      label: "Họ và tên",
      type: "custom",
      render: ({ value, onChange }) => {
        return <CKEditorWrapper value={value || ""} onChange={onChange} />
      },
    },
    subTitle: {
      label: "Chức vụ",
      type: "custom",
      render: ({ value, onChange }) => {
        return <CKEditorWrapper value={value || ""} onChange={onChange} />
      },
    },
    description: {
      label: "description",
      type: "array",
      arrayFields: {
        content: {
          label: "Content",
          type: "custom",
          render: ({ value, onChange }) => {
            return <CKEditorWrapper value={value || ""} onChange={onChange} />
          },
        },
      },
    },
    url: {
      label: "Link",
      type: "text",
    },
    ...commonStylesProps,
  },
  defaultProps: {
    title: "Thầy Hoàng Anh Đức",
    subTitle: "Tổng Giám Đốc",
    description: [
      { content: "Lorem ipsum dolor sit nih amet consect" },
      { content: "Lorem ipsum dolor sit nih amet consect" },
    ],
    className: "",
  },
  ...RenderConfig,
}
